import script from "./EmailInbox.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailInbox.vue?vue&type=script&setup=true&lang=js"

import "./EmailInbox.vue?vue&type=style&index=0&id=ecd5f57e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecd5f57e"]])

export default __exports__